import axios from "axios";

const BFF_BASE_URL = import.meta.env.VITE_BFF_SERVICE_URL;

export const api = (token: string) =>
  axios.create({
    baseURL: BFF_BASE_URL,
    headers: { Authorization: `Bearer ${token}`, accept: "application/json" },
  });
